const changeGridLayout = () => {
  const layoutBtnElement = document.querySelector(`.js-layout-btn`);
  const layoutGridElements = document.querySelectorAll(`.js-layout-grid`);

  if (layoutBtnElement && layoutGridElements.length) {
    function changeLayout(boolean) {
      if (boolean) {
        layoutGridElements.forEach((layoutGridElement) => layoutGridElement.classList.replace(`brands__grid--list`, `brands__grid--plate`));
      } else {
        layoutGridElements.forEach((layoutGridElement) => layoutGridElement.classList.replace(`brands__grid--plate`, `brands__grid--list`));
      }
    }

    function onLayoutBtnElementClick() {
      if (layoutBtnElement.classList.contains(`layout-btn--list`)) {
        layoutBtnElement.classList.replace(`layout-btn--list`, `layout-btn--plate`);
        layoutBtnElement.textContent = `Показать списком`;
        changeLayout(true);
      } else {
        layoutBtnElement.classList.replace(`layout-btn--plate`, `layout-btn--list`);
        layoutBtnElement.textContent = `Показать плиткой`;
        changeLayout(false);
      }
    }

    layoutBtnElement.addEventListener(`click`, onLayoutBtnElementClick);
  }
};

export {changeGridLayout};
